import React, {
  useState,
  useRef,
  useCallback,
  useLayoutEffect,
  useContext,
  useEffect,
} from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import CreateProjectWrapper from "./CreateProjectWrapper";
import Title from "./Title";
import Breadcrumbs from "./Breadcrumbs";
import Project from "./project/project";
import Home from "../pages/home";
import { ProjectContext } from "../utils/projectContext.js";
import create from "../imgs/create.png";
import open from "../imgs/open.png";
import { Input, Empty, Typography, Button, Popconfirm, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { getProjectList, deleteProject } from "../api/project/index.js";
import { useRequest } from "ahooks";
import moment from "moment/moment.js";
import title from "../imgs/title.png";
import { useLocation } from "react-router-dom";
import ThreeScene from "./threeScene";
import { useUpdateEffect } from "ahooks";

const AppContent = () => {
  const [showOptions, setShowOptions] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const { projectArr, setProjectArr } = useContext(ProjectContext);
  const { projectNow, setProjectNow } = useContext(ProjectContext);
  const [projectLists, setProjectLists] = useState([]);
  const stageRef = useRef(null);
  const [stageDimensions, setStageDimensions] = useState({
    width: 0,
    height: 0,
  });
  const navigate = useNavigate();
  const location = useLocation();
  // const { setCurrentIndex } = useContext(ProjectContext);

  // 显示智翎云境
  const { showCloudCity } = useContext(ProjectContext);

  const { runAsync: fetchProjectList } = useRequest(getProjectList, {
    manual: true,
    onSuccess: (res) => {
      if (res.code === 200) {
        setProjectLists(res.data);
        localStorage.setItem(
          "projectList",
          JSON.stringify(res.data.filter((item) => !item.isDeleted))
        );
      }
    },
    onError: (err) => {
      console.error("Error fetching project list:", err);
    },
  });

  const { runAsync: deleteProjectRequest } = useRequest(deleteProject, {
    manual: true,
    onSuccess: (res) => {
      if (res.code === 200) {
        message.success("删除成功");
        fetchProjectList({
          search: "",
        });
      }
    },
    onError: (err) => {
      message.error("删除失败");
      console.error("Error deleting project:", err);
    },
  });

  const confirmDelete = async () => {};
  const cancelDelete = () => {};

  useEffect(() => {
    fetchProjectList({
      search: "",
    });
  }, [location.pathname]);

  // useUpdateEffect(() => {
  //   if(!showCloudCity) {
  //     // 重置当前画布层级
  //     setCurrentIndex(0);
  //   }
  // }, [showCloudCity]);

  const handleResize = () => {
    if (stageRef.current) {
      let newWidth = stageRef.current.offsetWidth;
      let newHeight = stageRef.current.offsetHeight;
      if (stageDimensions.width !== newWidth || stageDimensions.height !== newHeight) {
        setStageDimensions({
          width: newWidth,
          height: newHeight,
        });
      }
    }
  };

  useLayoutEffect(() => {
    handleResize();
  });

  const closeProject = (e, index) => {
    e.stopPropagation();
    let newProjectArr = [...projectArr];
    newProjectArr.splice(index, 1);
    setProjectArr(newProjectArr);
    if (newProjectArr.length > 0) {
      setProjectNow(newProjectArr[0]);
      navigate(`/${newProjectArr[0].name}`);
    } else {
      setProjectNow({});
      navigate("/home");
    }
  };

  const handleClickItem = useCallback(
    (e, item) => {
      e.stopPropagation();
      setProjectNow(item);
      navigate(`/${item.name}`);
      console.log(item);
    },
    [navigate]
  );

  const openFile = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".json";
    input.onchange = (e) => {
      const file = e.target.files[0];
      const name = file.name.split(".")[0];
      const reader = new FileReader();
      // console.log(name,'name');
      reader.onload = (e) => {
        let newProjectArr = [...projectArr];
        let newProject = JSON.parse(e.target.result);
        newProject.name = name;
        newProject.canvasStyle = {
          background: newProject.objects[0].fill,
          width: newProject.objects[0].width,
          height: newProject.objects[0].height,
          unit: "px",
        };
        newProjectArr.push(newProject);
        setProjectArr(newProjectArr);
        setProjectNow(newProjectArr[newProjectArr.length - 1]);
        navigate(`/${newProjectArr[newProjectArr.length - 1].name}`);
      };
      reader.readAsText(file);
    };
    input.click();
  };
  const openData = (e, item) => {
    let newProjectArr = [...projectArr];
    let newProject = typeof item.data === "string" ? JSON.parse(item.data) : item.data;
    newProject.name = item.name;
    newProject.canvasStyle = {
      background: newProject.objects[0].fill,
      width: newProject.objects[0].width,
      height: newProject.objects[0].height,
      unit: "px",
    };
    newProjectArr.push(newProject);
    setProjectArr(newProjectArr);
    setProjectNow(newProjectArr[newProjectArr.length - 1]);
    navigate(`/${newProjectArr[newProjectArr.length - 1].name}`);
  };
  let searchTimer = null;

  useEffect(() => {
    console.log(projectNow,'当前projectNow项目数据！！！')
    if(projectNow.id) {
      localStorage.setItem("projectId", projectNow.id);
    }
  },[projectNow])

  return (
    <div className="app">
      <Title
        setShowOptions={setShowOptions}
        showOptions={showOptions}
        setShowCreate={setShowCreate}
        fetchProjectList={fetchProjectList}
      />
      <div className="main">
        {!showCloudCity && (
          <Breadcrumbs
            projectArr={projectArr}
            projectNow={projectNow}
            handleClickItem={handleClickItem}
            closeProject={closeProject}
          />
        )}

        <div className="container" onClick={() => setShowOptions(false)}>
          {showCreate ? (
            <CreateProjectWrapper
              setShowCreate={setShowCreate}
              setProjectArr={setProjectArr}
              setProjectNow={setProjectNow}
              projectArr={projectArr}
            />
          ) : projectArr.length <= 0 ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                padding: "40px 20%",
              }}
              className="projects"
            >
              <div className="btns" style={{ marginBottom: "20px" }}>
                <div className="btn create" onClick={() => setShowCreate(true)}>
                  <img src={create} alt="" />
                  <p>New project</p>
                </div>
                <div className="btn open" onClick={openFile}>
                  <img src={open} alt="" />
                  <p>Open project</p>
                </div>
              </div>
              <Input
                placeholder="搜索您的项目"
                size="large"
                onChange={(e) => {
                  console.log(e.target.value);
                  if (searchTimer) clearTimeout(searchTimer);
                  searchTimer = setTimeout(() => {
                    fetchProjectList({ search: e.target.value });
                  }, 1000);
                }}
                suffix={<SearchOutlined />}
              />
              <div className="myProjects">
                <p>我的项目</p>
                {projectLists.length > 0 ? (
                  <div className="items">
                    {projectLists.map((item, index) => {
                      if (!item.isDeleted) {
                        return (
                          <div className="item" key={index} onClick={(e) => openData(e, item)}>
                            <div className="img">
                              <img src={title} alt="" mode="withFixed" />
                            </div>
                            <div className="name">{item.name}</div>
                            <div className="time">
                              {(() => {
                                const date = moment(item.updatedAt);
                                return date.year() === moment().year()
                                  ? date.format("MM-DD HH:mm")
                                  : date.format("YYYY-MM");
                              })()}
                            </div>
                            <div className="btn">
                              <Popconfirm
                                title="一旦删除将无法恢复，确认要删除此项目吗?"
                                onConfirm={(e) => {
                                  e.stopPropagation();
                                  console.log(item);
                                  deleteProjectRequest({ id: item.id });
                                }}
                                onCancel={cancelDelete}
                                okText="确定"
                                cancelText="取消"
                              >
                                <Button type="primary" danger onClick={(e) => e.stopPropagation()}>
                                  删除
                                </Button>
                              </Popconfirm>
                            </div>
                          </div>
                        );
                      }
                    })}
                  </div>
                ) : (
                  <Empty
                    description={
                      <Typography.Text>
                        <p style={{ color: "#fff" }}>暂无数据</p>
                      </Typography.Text>
                    }
                  />
                )}
              </div>
            </div>
          ) : showCloudCity ? (
            <div>
              <ThreeScene />
            </div>
          ) : (
            <div className="stage" ref={stageRef}>
              <Home data={projectNow} stageDimensions={stageDimensions} />
            </div>
          )}
        </div>

        {projectArr.length > 0 && !showCloudCity && (
          <div className="sider">
            <Project data={projectNow} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AppContent;
